
import { EventBusKey } from "@/symbols"
import injectStrict from "@/utils/injectStrict"
import { defineComponent, nextTick, PropType, ref } from "vue"
type modalSize = "small" | "medium" | "large"

export default defineComponent({
  props: {
    size: { type: String as PropType<modalSize> },
    shown: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    let eventbus = injectStrict(EventBusKey)

    const showModal = () => {
      emit("update:shown", true)
      nextTick(() => eventbus.emit("onshown", this))
    }
    const hideModal = () => {
      emit("update:shown", false)
      nextTick(() => eventbus.emit("onhidden", this))
    }

    const getWidth = () => {
      switch (props.size) {
        case "small":
          return "400px !important"
        case "medium":
          return "800px !important"
        case "large":
          return "1024px !important"
        default:
          return "1024px !important"
      }
    }

    return {
      showModal,
      hideModal,
      eventbus,
      getWidth
    }
  }
})
